import { VisitForm } from 'components/visit-form';

export const NewVisitorPage = (): JSX.Element => <VisitForm />;
